var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30435 0H0V7.30435H7.30435V0ZM6.26087 1.04348H1.04348V6.26087H6.26087V1.04348Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6522 0H8.34783V7.30435H15.6522V0ZM14.6087 1.04348H9.3913V6.26087H14.6087V1.04348Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0H16.6957V7.30435H24V0ZM22.9565 1.04348H17.7391V6.26087H22.9565V1.04348Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30435 8.34783H0V15.6522H7.30435V8.34783ZM6.26087 9.3913H1.04348V14.6087H6.26087V9.3913Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6522 8.34783H8.34783V15.6522H15.6522V8.34783ZM14.6087 9.3913H9.3913V14.6087H14.6087V9.3913Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 8.34783H16.6957V15.6522H24V8.34783ZM22.9565 9.3913H17.7391V14.6087H22.9565V9.3913Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30435 16.6957H0V24H7.30435V16.6957ZM6.26087 17.7391H1.04348V22.9565H6.26087V17.7391Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6522 16.6957H8.34783V24H15.6522V16.6957ZM14.6087 17.7391H9.3913V22.9565H14.6087V17.7391Z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 16.6957H16.6957V24H24V16.6957ZM22.9565 17.7391H17.7391V22.9565H22.9565V17.7391Z",
    fill: "current"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1.04346 2.08698H6.26085V6.26089H1.04346V2.08698Z",
    fill: "current"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39128 5.21741H14.6087V6.26089H9.39128V5.21741Z",
    fill: "current"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.04346 12.5218H6.26085V14.6087H1.04346V12.5218Z",
    fill: "current"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39128 11.4783H14.6087V14.6087H9.39128V11.4783Z",
    fill: "current"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7391 17.7391H22.9565V22.9565H17.7391V17.7391Z",
    fill: "current"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39128 18.7826H14.6087V22.9565H9.39128V18.7826Z",
    fill: "current"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.04346 21.9131H6.26085V22.9565H1.04346V21.9131Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/Screen.15abba69386355e5ed21028eacc2e44d.svg";
export { ForwardRef as ReactComponent };